function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ns = /*#__PURE__*/function () {
  function ns(t) {
    _classCallCheck(this, ns);

    this.productId = t, this.productId = t;
  }

  _createClass(ns, [{
    key: "zc",
    value: function zc(t) {
      return null == this.productId || t[0] === this.productId;
    }
  }, {
    key: "bt",
    value: function bt() {
      return this.productId;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ns(t ? t.product_id : null);
    }
  }]);

  return ns;
}();

export { ns as default };